import React from 'react';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Helper from '../../utility/helper';

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
}));

const TransportationAccordianCard = (props) => {
    const classess = useStyles();
    const { classes, item } = props;
    const TransportationInfo = item.actualData;

    return (
        <>
            <Divider sx={{ mb: 1 }} />
            <Card sx={{ boxShadow: 'none', padding:'8px 16px 16px' }}>
                <CardContent className={classess.cardContent}>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(15%, 1fr))',
                            justifyContent: 'flex-start',
                            alignItems: 'left',
                            gap: '10px',
                            width: {
                                xs: '100%',
                                md: '100%',
                                lg: '100%',
                            },
                        }}
                    >
                        {/* {(TransportationInfo.transportType === "ground" || TransportationInfo.transitType === "Ground") ?
                            <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        First Name
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        style={{ wordWrap: 'break-word' }}>
                                        <span>
                                            {TransportationInfo.passangerName.split(',')[0]}
                                        </span>
                                    </Typography>
                                </Box>
                            </Box>
                            : null}
                        {(TransportationInfo.transportType === "ground" || TransportationInfo.transitType === "Ground") ?
                            <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Last Name
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        style={{ wordWrap: 'break-word' }}>
                                        <span>
                                            {TransportationInfo.passangerName.split(',')[1]}
                                        </span>
                                    </Typography>
                                </Box>
                            </Box>
                            : null} */}
                        {TransportationInfo.transportType === "air" ?
                            <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Person Name
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        style={{ wordWrap: 'break-word' }}>
                                        <span>
                                            {TransportationInfo.passangerName}
                                        </span>
                                    </Typography>
                                </Box>
                            </Box>
                            : null}
                        {props.enduser ? null :
                            <>{TransportationInfo.transportType === 'air' && TransportationInfo.totalPassengers !== null ? (
                                <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            Total Passenger
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}>
                                            <span>
                                                {
                                                    TransportationInfo.totalPassengers
                                                }
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box>
                            ) : null}
                                {TransportationInfo.fromDate !== "0001-01-01T00:00:00" ?
                                    <Box
                                        sx={{
                                            width: '180px',
                                            flexBasis: '180px',
                                            flexGrow: 1,
                                        }}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'left',
                                                alignItems: 'left',
                                            }}>
                                            <Typography
                                                variant="h4"
                                                fontSize={12}
                                                fontWeight={500}
                                                color="primary">
                                                {TransportationInfo.transportType === 'air' ? "Date/Time" : "Start Date"}
                                            </Typography>
                                            <Typography
                                                variant="h4"
                                                fontSize={14}
                                                fontWeight={400}>
                                                <span>
                                                    {(Helper.FormatTime24(TransportationInfo.fromDate) != '00:00' || Helper.FormatTime24(TransportationInfo.fromDate) != '12:00') ? Helper.FormatDatewithoutTime(TransportationInfo.fromDate) : Helper.FormatDateTime(
                                                        TransportationInfo.fromDate
                                                    )}
                                                </span>
                                            </Typography>
                                        </Box>
                                    </Box> : null}
                                {TransportationInfo.toDate !== "0001-01-01T00:00:00" ?
                                    <Box
                                        sx={{
                                            width: '180px',
                                            flexBasis: '180px',
                                            flexGrow: 1,
                                        }}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'left',
                                                alignItems: 'left',
                                            }}>
                                            <Typography
                                                variant="h4"
                                                fontSize={12}
                                                fontWeight={500}
                                                color="primary">
                                                {TransportationInfo.transportType === 'air' ? "Date/Time" : "DropOff Date"}
                                            </Typography>
                                            <Typography
                                                variant="h4"
                                                fontSize={14}
                                                fontWeight={400}>
                                                <span>
                                                    {(Helper.FormatTime24(TransportationInfo.toDate) != '00:00' || Helper.FormatTime24(TransportationInfo.toDate) != '12:00') ? Helper.FormatDatewithoutTime(TransportationInfo.toDate) : Helper.FormatDateTime(
                                                        TransportationInfo.toDate
                                                    )}
                                                </span>
                                            </Typography>
                                        </Box>
                                    </Box> : null}
                                <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            {TransportationInfo.transportType === 'air' ? 'Departure Airport' : 'Pickup Location'}

                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}
                                            style={{ wordWrap: 'break-word' }}>
                                            <span>
                                                {TransportationInfo.fromLocation}
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box>

                                <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            {TransportationInfo.transportType === 'air' ? 'Arrival Airport' : 'Dropff Location'}
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            // flexGrow={1}
                                            fontSize={14}
                                            fontWeight={400}
                                            style={{ wordWrap: 'break-word' }}>
                                            <span>{TransportationInfo.toLocation}</span>
                                        </Typography>
                                    </Box>
                                </Box>
                            </>}
                        {TransportationInfo.passangerEmail ? (
                            <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Email
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        style={{ wordWrap: 'break-word' }}>
                                        <span>
                                            {TransportationInfo.passangerEmail}
                                        </span>
                                    </Typography>
                                </Box>
                            </Box>
                        ) : null}

                        {TransportationInfo.passangerContact ? (
                            <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Contact
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        style={{ wordWrap: 'break-word' }}>
                                        <span>
                                            {
                                                TransportationInfo.passangerContact
                                            }
                                        </span>
                                    </Typography>
                                </Box>
                            </Box>
                        ) : null}
                    </Box>
                    {(TransportationInfo.transportType == 'air' || TransportationInfo.transitType == 'Air') ? (
                        <Box
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fill, minmax(15%, 1fr))',
                                justifyContent: 'flex-start',
                                alignItems: 'left',
                                gap: '10px',
                                width: {
                                    xs: '100%',
                                    md: '100%',
                                    lg: '100%',
                                },
                                mt: '8px',
                            }}
                        >
                            {TransportationInfo.transitType === "Air" ?
                                <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            Person Name
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}
                                            style={{ wordWrap: 'break-word' }}>
                                            <span>
                                                {TransportationInfo.passangerName}
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box>
                                : null}
                            {(TransportationInfo.totalPassengers !== null) && (props.enduser) ? (
                                <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            Total Passenger
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}>
                                            <span>
                                                {
                                                    TransportationInfo.totalPassengers
                                                }
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box>
                            ) : null}
                            {(TransportationInfo.airline != '' && TransportationInfo.isPrivate === false) ? (
                                <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            Airline
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}
                                            style={{ wordWrap: 'break-word' }}>
                                            <span>
                                                {TransportationInfo.airline}
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box>
                            ) : null}
                            {TransportationInfo.flightNo != '' ? (
                                <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            {TransportationInfo.isPrivate ? "Tail No" : "Flight No"}
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}
                                            style={{ wordWrap: 'break-word' }}>
                                            <span>
                                                {TransportationInfo.flightNo}
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box>
                            ) : null}
                            {TransportationInfo.comments ? (
                                <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            Comments
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}
                                            style={{ wordWrap: 'break-word' }}>
                                            <span>
                                                {TransportationInfo.comments}
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box>
                            ) : null}
                            {/* {TransportationInfo.ticketID ? (
                                    <Box
                                        sx={{
                                            width: '180px',
                                            flexBasis: '180px',
                                            flexGrow: 1,
                                        }}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'left',
                                                alignItems: 'left',
                                            }}>
                                            <Typography
                                                variant="h4"
                                                fontSize={12}
                                                fontWeight={500}
                                                color="primary">
                                                Ticket Type
                                            </Typography>
                                            <Typography
                                                variant="h4"
                                                fontSize={14}
                                                fontWeight={400}>
                                                <span>
                                                    {TransportationInfo.ticketID &&
                                                        TransportationInfo.ticketID ===
                                                        1
                                                        ? 'Business'
                                                        : 'Economy'}
                                                </span>
                                            </Typography>
                                        </Box>
                                    </Box>
                                ) : null} */}
                            <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        IsPrivate
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}>
                                        <span>
                                            {
                                                TransportationInfo.isPrivate === true ? 'Yes' : 'No'
                                            }
                                        </span>
                                    </Typography>
                                </Box>
                            </Box>
                            {TransportationInfo.lastModifiedDate !== "0001-01-01T00:00:00"
                                && TransportationInfo.lastModifiedDate !== null ? (
                                <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            Modified Date
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}
                                            style={{ wordWrap: 'break-word' }}>
                                            <span>
                                                {
                                                    Helper.FormatDateTime(TransportationInfo.lastModifiedDate)
                                                }
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box>
                            ) : null}
                            {/* <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            DOB
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}
                                            style={{ wordWrap: 'break-word' }}>
                                            <span>
                                                {
                                                    TransportationInfo.passangerDOB !== null ? Helper.FormatDate(TransportationInfo.passangerDOB) : ''
                                                }
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box>  */}
                            {(TransportationInfo.contactNo !== null || TransportationInfo.contactNo !== "") ? <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Contact No
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        style={{ wordWrap: 'break-word' }}>
                                        <span>
                                            {
                                                TransportationInfo.contactNo !== null ? TransportationInfo.contactNo.replace(
                                                    /(\d{3})(\d{3})(\d{4})/,
                                                    ' $1 $2 $3'
                                                ) : ''
                                            }
                                        </span>
                                    </Typography>
                                </Box>
                            </Box> : null}
                            {(TransportationInfo.dropoff !== null || TransportationInfo.dropoff !== "") ? <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Drop-Off
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        style={{ wordWrap: 'break-word' }}>
                                        <span>
                                            {TransportationInfo.dropoff}
                                        </span>
                                    </Typography>
                                </Box>
                            </Box> : null}
                        </Box>
                    ) : null}
                </CardContent>
            </Card>
        </>
    );
};

export default TransportationAccordianCard;
